// extracted by mini-css-extract-plugin
export default {"ResetPassword":"ResetPassword_ResetPassword__q5UGj"};